<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="data" noDataText="Nenhum item encontrado no período selecionado">
      <template slot="thead">
        <vs-th sort-key="datetime">DATA/HORA DO ARQUIVO</vs-th>
        <vs-th sort-key="name">DISPOSITIVO</vs-th>
        <vs-th sort-key="name">NOME DO ARQUIVO</vs-th>
        <vs-th sort-key="name">BAIXAR</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-show="loading">
          <vs-td class="text-nowrap" colspan="5">
            <div id="loading" class="vs-con-loading__container"></div>
          </vs-td>
        </vs-tr>
        <vs-tr :data="linha" :key="index" v-for="(linha, index) in data">
          <vs-td class="text-nowrap">
            <span>{{ data[index].datetime | formatDateTime }}</span>
          </vs-td>
          <vs-td>
            <span>{{ data[index].alias }}</span>
          </vs-td>
          <vs-td>
            <span>{{ data[index].filename }}</span>
          </vs-td>
          <vs-td>
            <a :href="`${data[index].url}`" v-if="data[index].url"
               class="p-3 rounded-lg cursor-pointer flex inline-flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
              <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Baixar Arquivo</span>
            </a>

            <div v-show="!data[index].url">
              Tarefa Agendada
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      loading: true
    }
  },

  watch: {
    page: function () {
      this.load()
    }
  },

  mounted() {
    this.load()

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    })
  },

  methods: {
    load: function () {
      this.$api
      .get(
        `/api/v1/downloadTask`
      )
      .then((response) => {
        this.loading = false
        this.data = response.data.data
      })
    }
  }
}
</script>

<style lang="scss">
.trava {
  position: absolute;
  background: rgba(255, 255, 255, 0.9);
  bottom: 0px;
  height: calc(100% - 300px);
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      margin-top: 0px;
    }
  }
}

@media (max-width: 576px) {
  .box {
    width: 300px;
    height: auto;
    background: #fff;
  }
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
